import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/questionnaire/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/questionnaireProblem/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/questionnaire/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/questionnaire/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/questionnaire/delete/${id}`)
}

// 问卷详情
export function questionnaireDetail (id) {
  return request.get(`/business/questionnaire/${id}`)
}
export function questionnaireAnswerDetail (id) {
  return request.get(`/business/declareAnswer/${id}`)
}
export function exportAnswerExcel (data) {
  return request.post('/business/declareAnswer/exportAnswerExcel', data, {
    trim: true,
    download: true
  })
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/questionnaire/delete/batch', {
    params: {
      ids
    }
  })
}
